import * as React from 'react';
import { 
  Box,
  IconButton,

} from '@mui/material';
// import { TreeItem } from '@mui/x-tree-view/TreeItem';
import { RichTreeView } from '@mui/x-tree-view';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import LockOpenOutlinedIcon from '@mui/icons-material/LockOpenOutlined';
import { TreeItem, TreeItemContent } from '@mui/x-tree-view/TreeItem';
import {useTreeItem} from '@mui/x-tree-view/useTreeItem'

import AuthModal from '../../modals/AuthModal';

function CustomContent({ children, toggleItemDisabled, itemId, ...props }) {
  const isTopLevel = itemId?.split('^').length === 1;
  const strList = itemId.split('#');
  let disabled = strList[1] === 'False' ? true: false;
  let sourceName = strList[0];
  const [openAuth, setOpenAuth] = React.useState(false);

  const handleClose = () => {
    setOpenAuth(false)
  }

  const handleAuthModal = () => {
    setOpenAuth(true)
  }

  const handleSave = (username, password) => {
    // This will be enhanced to save credentials to the backend
    console.log('Saving credentials for:', sourceName, username, password);
    // After successful save, refresh the hierarchy to update lock status
    setOpenAuth(false);
  }

  return (
    <>
    <TreeItemContent {...props}>
      {children}
      {isTopLevel && (
        <IconButton
          size="small"
          onClick={handleAuthModal}
          disabled={!disabled}
        >
          {disabled ? (
            <LockOutlinedIcon fontSize="small" />
          ) : (
            <LockOpenOutlinedIcon fontSize="small" />
          )}
        </IconButton>
      )}
    </TreeItemContent>
    <AuthModal open={openAuth} sourceName={sourceName} handleClose={handleClose} handleSave={handleSave} />
    </>
  );
}

const CustomTreeItem = React.forwardRef(function CustomTreeItem(props, ref) {
  const { publicAPI, status } = useTreeItem(props);

  const toggleItemDisabled = () =>
    publicAPI.setIsItemDisabled({
      itemId: props.itemId,
      isItemDisabled: !status.disabled,
    });

  return (
    <TreeItem
      {...props}
      ref={ref}
      slots={{
        content: CustomContent,
      }}
      slotProps={{
        content: {
          toggleItemDisabled,
          disabled: status.disabled,
          itemId: props.itemId
        },
      }}
    />
  );
});

export default function SourceTree(props) {
  const { data, onSelectSession } = props;
  const [treeItems, setTreeItems] = React.useState([])

  const renderTreeItems = (items, root) => (  
    items.map(item => (  
      <TreeItem key={item.name} itemId={`${root}^${item.name}`} label={item.name}>  
        {item.items && item.items.length > 0 && renderTreeItems(item.items, `${root}^${item.name}`)}  
      </TreeItem>  
    ))  
  );

  React.useEffect(() => {
    const mapTreeItems = mapDataToMUIXProducts(data);
    setTreeItems(mapTreeItems)
  }, data)

  const getCredentialStatus = (id) => {
    const treeItem = data.filter(item => item.name === id);
    if (treeItem.length === 0) return { is_admin_credential: true };
    
    const { is_admin_credential } = treeItem[0];
    return { 
      is_admin_credential: is_admin_credential || false
    };
  }

  const mapDataToMUIXProducts = (data) => {
    return data.map((source) => {
      // Determine lock status based on admin credential status
      let lockStatus = 'True'; // Default to unlocked (admin credentials)
      
      if (source.is_admin_credential === false) {
        lockStatus = 'False'; // Locked - no admin credentials
      }
      
      // Check if this is an Oracle EPM source (3-level: source → cube → session)
      const isOracleEPM = source.type === 'oracleepm';
      
      if (isOracleEPM) {
        // For Oracle EPM: source → cube → session
        return {
          id: `${source.name}#${lockStatus}`,
          label: source.name,
          children: (source.items || []).map((cube) => ({
            id: `${source.name}^${cube.name}`,
            label: cube.name,
            children: (cube.items || []).map((session) => ({
              id: `${source.name}^${cube.name}^${session.name}`,
              label: session.name,
            })),
          })),
        };
      } else {
        // For regular sources: source → session (2-level)
        return {
          id: `${source.name}#${lockStatus}`,
          label: source.name,
          children: (source.items || []).map((item) => ({
            id: `${source.name}^${item.name}`,
            label: item.name,
          })),
        };
      }
    });
  }

  const getSourceType = (sourceName) => {
    const treeItem = data.filter(item => item.name === sourceName);
    if (treeItem.length === 0) return null;
    return treeItem[0].type;
  }

  const handleItem = (e, itemId) => {
    if (itemId.includes('#'))
    {
      // Source level clicked
      let strList = itemId.split('#');
      let sourceName = strList[0];
      let sourceType = getSourceType(sourceName);
      let credentialInfo = getCredentialStatus(sourceName);
      
      onSelectSession(sourceName, sourceType, '', null, credentialInfo.is_admin_credential);
    }
    else {
      let strList = itemId.split('^');
      let sourceName = strList[0];
      let sourceType = getSourceType(sourceName);
      
      // Check if this is Oracle EPM (3-level: source^cube^session)
      if (sourceType === 'oracleepm' && strList.length === 3) {
        // Oracle EPM session clicked: source^cube^session
        let cubeName = strList[1];
        let sessionName = strList[2];
        let credentialInfo = getCredentialStatus(sourceName);
        
        onSelectSession(sourceName, sourceType, sessionName, cubeName, credentialInfo.is_admin_credential);
      } else if (sourceType === 'oracleepm' && strList.length === 2) {
        // Oracle EPM cube clicked
        let cubeName = strList[1];
        let credentialInfo = getCredentialStatus(sourceName);
        onSelectSession(sourceName, sourceType, '', cubeName, credentialInfo.is_admin_credential);
      } else {
        // Regular session clicked: source^session
        let sessionName = strList.length > 1 ? strList[1] : '';
        let credentialInfo = getCredentialStatus(sourceName);
        
        onSelectSession(sourceName, sourceType, sessionName, null, credentialInfo.is_admin_credential);
      }
    }
  }

  return (
    <Box>
      <RichTreeView
        defaultExpandedItems={[]}
        items={treeItems}
        slots={{ item: CustomTreeItem }}
        onItemClick={handleItem}
      />
    </Box>
  );
}